import type { DropdownOption } from "../redistribution/models/DropdownOption.ts";
import { getWarehouseKey } from "./warehouseKeys.ts";

export function formatWarehouseLabel(
  rawLabel: string,
  warehouseNumber: string
): string {
  const trimmed = rawLabel.trim();
  const match = /^(.*?)[\s-]+(\d+)$/.exec(trimmed);
  if (!match) {
    return `${trimmed} - ${warehouseNumber}`;
  }
  const namePartRaw = match[1];
  const numberPartRaw = match[2];
  if (namePartRaw === undefined) {
    return `${trimmed} - ${warehouseNumber}`;
  }
  const namePart = namePartRaw.trim();
  const numberPart = numberPartRaw?.trim() ?? warehouseNumber;
  return `${namePart} - ${numberPart}`;
}

export function getWarehouseDisplay(
  division: string,
  warehouse: number,
  warehouseOptions: DropdownOption[],
  fallbackWarehouseName?: string
): string {
  const warehouseNumber = String(warehouse);
  const selected = warehouseOptions.find(
    (option) => option.value === getWarehouseKey(division, warehouse)
  );
  if (selected) {
    return formatWarehouseLabel(selected.label, warehouseNumber);
  }
  if (fallbackWarehouseName) {
    return formatWarehouseLabel(fallbackWarehouseName, warehouseNumber);
  }
  return `Warehouse ${warehouseNumber} - ${warehouseNumber}`;
}
